import { createSlice } from '@reduxjs/toolkit'

const THEME_STORAGE_KEY = 'hpilot-theme'

// Get initial theme from localStorage or use 'light' as default
const getInitialTheme = () => {
  if (typeof window !== 'undefined') {
    const savedTheme = localStorage.getItem(THEME_STORAGE_KEY)
    if (savedTheme && (savedTheme === 'light' || savedTheme === 'dark')) {
      return savedTheme
    }
    // Detect system preference
    if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
      return 'dark'
    }
  }
  return 'light'
}

const initialState = {
  mode: getInitialTheme()
}

const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    toggleTheme: (state) => {
      state.mode = state.mode === 'light' ? 'dark' : 'light'
      // Persist to localStorage
      if (typeof window !== 'undefined') {
        localStorage.setItem(THEME_STORAGE_KEY, state.mode)
        // Apply theme to HTML
        document.documentElement.setAttribute('data-theme', state.mode)
      }
    },
    setTheme: (state, action) => {
      const newTheme = action.payload
      if (newTheme === 'light' || newTheme === 'dark') {
        state.mode = newTheme
        // Persist to localStorage
        if (typeof window !== 'undefined') {
          localStorage.setItem(THEME_STORAGE_KEY, newTheme)
          // Apply theme to HTML
          document.documentElement.setAttribute('data-theme', newTheme)
        }
      }
    },
    initializeTheme: (state) => {
      // Apply current theme to HTML when initialized
      if (typeof window !== 'undefined') {
        document.documentElement.setAttribute('data-theme', state.mode)
      }
    }
  }
})

export const { toggleTheme, setTheme, initializeTheme } = themeSlice.actions

export default themeSlice.reducer

// Selectors
export const selectTheme = (state) => state.theme.mode
export const selectIsDarkMode = (state) => state.theme.mode === 'dark'

